/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetMonthlyDrivingInfoResponse } from '../models/ApiResponseGetMonthlyDrivingInfoResponse';
import type { ApiResponseGetMonthlyFuelEfficiencyResponse } from '../models/ApiResponseGetMonthlyFuelEfficiencyResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FuelService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 월별 연비/전비 조회
   * 차량의 월별 연비/전비를 조회합니다.
   * @returns ApiResponseGetMonthlyFuelEfficiencyResponse OK
   * @throws ApiError
   */
  public getMonthlyDriveStats2({
    vin,
    authorization,
    userId,
    startDate,
    endDate,
  }: {
    vin: string,
    authorization?: string,
    userId?: string,
    startDate?: string,
    endDate?: string,
  }): CancelablePromise<ApiResponseGetMonthlyFuelEfficiencyResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/car/trip/fuel-efficiency',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'userId': userId,
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }
  /**
   * 월별 연비/전비 조회
   * 차량의 월별 연비/전비를 조회합니다.
   * @returns ApiResponseGetMonthlyFuelEfficiencyResponse OK
   * @throws ApiError
   */
  public getMonthlyDriveStats3({
    vin,
    authorization,
    userId,
    startDate,
    endDate,
  }: {
    vin: string,
    authorization?: string,
    userId?: string,
    startDate?: string,
    endDate?: string,
  }): CancelablePromise<ApiResponseGetMonthlyFuelEfficiencyResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/car/trip/fuel-efficiency/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'userId': userId,
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }
  /**
   * 월별 주행 정보 조회
   * 차량의 월별 주행 정보를 조회합니다.
   * @returns ApiResponseGetMonthlyDrivingInfoResponse OK
   * @throws ApiError
   */
  public getMonthlyDrivingInfo({
    vin,
    ccId,
    authorization,
    startDate = '202506',
    endDate = '202510',
  }: {
    vin: string,
    ccId: string,
    authorization?: string,
    startDate?: string,
    endDate?: string,
  }): CancelablePromise<ApiResponseGetMonthlyDrivingInfoResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/car/trip/driving-info',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }
}
